(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["momyco-press"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('momyco-press[data-mp-root]:not([data-mp-init])').forEach(function (root) {
      root.setAttribute('data-mp-init', '');
      var modal = root.querySelector('[data-mp-modal]');
      if (!modal) return;
      var panel = modal.querySelector('.mp__panel');
      var lastFocused = null;

      var el = {
        pub: modal.querySelector('[data-mp-pub]'),
        byline: modal.querySelector('[data-mp-byline]'),
        title: modal.querySelector('[data-mp-title]'),
        lead: modal.querySelector('[data-mp-lead]'),
        body: modal.querySelector('[data-mp-body]'),
        quote: modal.querySelector('[data-mp-quote]'),
        endmark: modal.querySelector('[data-mp-endmark]'),
        media: modal.querySelector('[data-mp-media]'),
        img: modal.querySelector('[data-mp-img]')
      };

      function setText(node, value) {
        if (!node) return;
        if (value) { node.textContent = value; node.hidden = false; }
        else { node.textContent = ''; node.hidden = true; }
      }
      function setHTML(node, html) {
        if (!node) return;
        if (html && html.trim()) { node.innerHTML = html; node.hidden = false; }
        else { node.innerHTML = ''; node.hidden = true; }
      }
      function tplHTML(btn, sel) {
        var t = btn.querySelector(sel);
        return t ? t.innerHTML : '';
      }

      function open(btn) {
        lastFocused = btn;
        if (el.pub) el.pub.textContent = btn.getAttribute('data-mp-name') || '';
        el.title.textContent = btn.getAttribute('data-mp-title') || '';

        var date = btn.getAttribute('data-mp-date') || '';
        var author = btn.getAttribute('data-mp-byline') || '';
        var byline = '';
        if (author && date) byline = author + ' · ' + date;
        else byline = author || date;
        setText(el.byline, byline);

        setHTML(el.lead, tplHTML(btn, '.mp__lead-src'));
        setHTML(el.body, tplHTML(btn, '.mp__body-src'));
        setText(el.quote, btn.getAttribute('data-mp-quote'));
        if (el.endmark) el.endmark.hidden = !(el.body && !el.body.hidden);

        var imgSrc = btn.getAttribute('data-mp-img');
        if (imgSrc) { el.img.src = imgSrc; el.img.alt = btn.getAttribute('data-mp-title') || ''; el.media.hidden = false; }
        else { el.img.removeAttribute('src'); el.media.hidden = true; }

        modal.hidden = false;
        void modal.offsetWidth;
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        if (panel) { panel.scrollTop = 0; panel.focus(); }
        document.addEventListener('keydown', onKey);
      }

      function close() {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        var done = function () { modal.hidden = true; panel.removeEventListener('transitionend', done); };
        panel.addEventListener('transitionend', done);
        setTimeout(function () { if (!modal.classList.contains('is-open')) modal.hidden = true; }, 450);
        if (lastFocused) lastFocused.focus();
      }

      function onKey(e) {
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab' && modal.classList.contains('is-open')) {
          var f = modal.querySelectorAll('a[href], button:not([disabled])');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }

      root.querySelectorAll('[data-mp-open]').forEach(function (btn) {
        btn.addEventListener('click', function () { open(btn); });
      });
      modal.querySelectorAll('[data-mp-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
